import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import Image from "../components/image"
import pic from "../images/walk_site_header_image.png"
import HeaderImage from "./header-image";
import HeaderImageTitle from "./header-title-image";

const Header = ({ siteTitle }) => (<>
  {/* <div className="section is-marginless">
  <h1 className="title main-title is-size-1-desktop is-size-2-tablet is-size-3-mobile header-font is-capitalized" style={{marginBottom: '10px'}}>Walk With Me</h1>
  <h2 className="title is-size-5 is-size-4-widescreen is-size-5-desktop is-size-6-tablet is-size-7-mobile header-font subtitle">Stories of Johannesburg like you've never heard them before</h2>

  </div> */}
  <header className="section is-marginless top-background"
  >
  <div className="container parent-height"
    >
  {/* <HeaderImage/> */}
  <div className="header-text-main parent-height" style={{paddingBottom: 0}}>
  {/* <HeaderImageTitle /> */}
  <h1 className="title main-title is-size-1-desktop is-size-2-tablet is-size-3-mobile header-font is-uppercase" style={{marginBottom: 0}}>Walk With Me</h1>
  <h2 className="title is-size-5 is-size-4-widescreen is-size-5-desktop is-size-6-tablet is-size-7-mobile header-font subtitle" style={{ maxWidth: '57%'}}>Stories of Johannesburg like you've never heard them before</h2>
  {/* <h1 class="aspect-ratio-box">
  <div class="aspect-ratio-box-inside">
    <div class="flexbox-centering">
      <div class="viewport-sizing">
          Happy Birthday
      </div>
    </div>
  </div>
</h1> */}

  </div>
  </div>
  </header>
  </>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
